import { css } from '@emotion/react';

export const stopTextContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: content-box;
  max-width: 400px;
  padding: 0 16px;
`;

export const firstLine = css`
  > p {
    display: inline;
  }
`;
